export const extractErrorText = responseData => Object.values(responseData || {}).flat().join(' ');
